// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"22f7eee2","114":"22a2b556","175":"9972cbf8","523":"4df133cd","529":"22a61ca1","560":"93ebf342","569":"a903d4ae","710":"9b67aad5"}[chunkId] + ".chunk.js";
};